import React from 'react'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'

// helpers
import { capitalizeFirstLetter } from 'src/helpers/text-format'

const AppDetails = ({
  userDetails,
}) => {
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="First name"
          className='mb-3'
          subtitle={userDetails?.profile?.first_name ? capitalizeFirstLetter(userDetails?.profile?.first_name) : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Last name"
          className='mb-3'
          subtitle={userDetails?.profile?.last_name ? capitalizeFirstLetter(userDetails?.profile?.last_name) : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Username"
          className='mb-3'
          subtitle={userDetails?.username ? userDetails?.username : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Email address"
          className='mb-3'
          subtitle={userDetails?.email ? userDetails?.email : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Status User"
          className='mb-3'
          subtitle={userDetails?.is_active === true ? 'Active' : 'Inactive'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Gender"
          className='mb-3'
          subtitle={userDetails?.profile?.gender ? capitalizeFirstLetter(userDetails?.profile?.gender) : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Phone Number"
          className='mb-3'
          subtitle={userDetails?.profile?.phone_number ? `${userDetails?.profile?.country?.phone_code}${userDetails?.profile?.phone_number}` : '-'}
        />
      </CRow>
    </>
  )
}

export default AppDetails
